/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Card, Button } from "react-bootstrap";
import { camelToTitleCase } from "../../utility";

const VoicemailDetails = ({ attributes, initiateOutboundCall }) => {
	return (
		<Card style={{ padding: "8px", marginBottom: "5px", width: "100%" }}>
			<Button
				size="sm"
				className="position-absolute px-3"
				variant="outline-secondary"
				onClick={initiateOutboundCall}
				style={{ top: 9, right: 9, height: "31px", textAlign: "center", maxWidth: "100px" }}
			>
				Call
			</Button>
			{attributes.map((attr) => {
				return (
					<div key={attr.name} style={{ display: "flex", justifyContent: "space-between", margin: "5px 0" }}>
						<div>
							<label style={{ fontWeight: 600, marginRight: "5px", marginBottom: 0 }}>
								{camelToTitleCase(attr.name)}:
							</label>
							<span style={{ wordBreak: "break-word", lineHeight: "1.4em" }}>{attr.value}</span>
						</div>
					</div>
				);
			})}
		</Card>
	);
};

export default VoicemailDetails;
